module.exports = __webpack_public_path__ + "static/img/78055E_2_3_R_20191024_fit.04d47e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/78055E_2_3_R_20191024_fit.png
// module id = k33T
// module chunks = 0